/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiKeyScope } from './ApiKeyScope';
import {
    ApiKeyScopeFromJSON,
    ApiKeyScopeFromJSONTyped,
    ApiKeyScopeToJSON,
    ApiKeyScopeToJSONTyped,
} from './ApiKeyScope';

/**
 * 
 * @export
 * @interface CreateApiKeyRequest
 */
export interface CreateApiKeyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateApiKeyRequest
     */
    name: string;
    /**
     * 
     * @type {Array<ApiKeyScope>}
     * @memberof CreateApiKeyRequest
     */
    scopes: Array<ApiKeyScope>;
    /**
     * Optional expiry; must be in the future. Omit for a non-expiring key.
     * @type {Date}
     * @memberof CreateApiKeyRequest
     */
    expiresAt?: Date | null;
}

/**
 * Check if a given object implements the CreateApiKeyRequest interface.
 */
export function instanceOfCreateApiKeyRequest(value: object): value is CreateApiKeyRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('scopes' in value) || value['scopes'] === undefined) return false;
    return true;
}

export function CreateApiKeyRequestFromJSON(json: any): CreateApiKeyRequest {
    return CreateApiKeyRequestFromJSONTyped(json, false);
}

export function CreateApiKeyRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateApiKeyRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'scopes': ((json['scopes'] as Array<any>).map(ApiKeyScopeFromJSON)),
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
    };
}

export function CreateApiKeyRequestToJSON(json: any): CreateApiKeyRequest {
    return CreateApiKeyRequestToJSONTyped(json, false);
}

export function CreateApiKeyRequestToJSONTyped(value?: CreateApiKeyRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'scopes': ((value['scopes'] as Array<any>).map(ApiKeyScopeToJSON)),
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt'] as any).toISOString()),
    };
}

